import { OneLineCounter } from "./Components/OneLineCounter";
import { game } from "./main";
import { makeImage } from "./utils/makeImage";

export class DifficultyDisplayBox extends Phaser.Group {
    private bg: Phaser.Image;
    private score: number;
    private counterTxt: OneLineCounter;

    constructor(x: number, y: number) {
        super(game);

        this.position.setTo(x, y);

        this.bg = makeImage(0, 0, 'bg_numbers_hud', 0.5, this);
        this.score = 0;

        this.counterTxt = new OneLineCounter(0, 0, 'font', 0, 30, 180, 0.5, 0.5);
        this.counterTxt.text = [game.getText(9), game.getText(10), game.getText(11)][game.gameDifficultyLevel];
        this.add(this.counterTxt);
    }

    public set value(diff: string) {
        this.counterTxt.text = diff;
    }

};